<template>
    <div class="print-dialog">
        <el-dialog
            :custom-class="dialogClassName"
            :visible.sync="printDialogVisible"
            :loading="loading"
            :title="dialogTitle"
            :width="dialogWidth"
            :before-close="handleBeforeClose"
        >
            <div ref="iframeWrap" class="iframe_wrap"></div>
        </el-dialog>
    </div>
</template>
<script>
import { IframeBridge } from '@qsen/iframe-bridge';
const IframeId = 'printConfirmConfig';
export default {
    name: 'AsPrintDialog',
    data() {
        return {
            printDialogVisible: false,
            loading: false,
            iframeBridge: null,
            isPrinting: false,
            printComplete: false
        }
    },
    computed: {
        dialogWidth() {
            return this.isPrinting ? '370px' : '625px'
        },
        dialogTitle() {
            return this.isPrinting ? "" : "打印快递单"
        },
        dialogClassName() {
            return this.isPrinting ? "print-dialog-container__printing" : "print-dialog-container";
        },
    },
    methods: {
        handleBeforeClose(done) {
            if (this.printComplete || !this.isPrinting) {
                if (this.printComplete) {
                    this.options.completeCallback && this.options.completeCallback();
                }
                done();
            }
        },
        updateIframeHeight(value) {
            const iframeEl = this.iframeBridge.getIframe(IframeId);
            iframeEl.height = value;
        },
        initIframeBridge() {
            return new Promise((resolve, reject) => {
                if (this.iframeBridge) {
                    this.updateIframeHeight("332px");
                    resolve();
                    return;
                }
                // 创建实例
                this.iframeBridge = new IframeBridge({
                    allowedOrigins: ['*.meiguanjia.net',], // 允许通信的域名列表
                    timeout: 15 * 1000,  // iframe 加载超时时间（毫秒）
                    debug: true     // 开启调试日志
                });
                this.iframeBridge.on("printConfirmHide", () => {
                    this.printDialogVisible = false;
                })
                this.iframeBridge.on("printConfirmStart", () => {
                    this.isPrinting = true;
                    this.updateIframeHeight("230px");
                })
                this.iframeBridge.on("printConfirmComplete", () => {
                    this.printComplete = true;
                })
                this.iframeBridge.on("printConfirmAddAddress", () => {
                    this.options.openAddressConfig && this.options.openAddressConfig();
                })
                this.$nextTick(() => {
                    this.iframeBridge.mount(this.$refs.iframeWrap, {
                        name: IframeId,
                        url: `${window.location.origin}/express/#/print`,
                        height: '332px',
                        width: "100%",
                    }).then(() => {
                        resolve();
                    }).catch(reject);
                })
            })
        },
        show(options) {
            this.isPrinting = false;
            this.printComplete = false;
            this.loading = true;
            this.options = options;
            this.printDialogVisible = true;
            this.initIframeBridge().then(() => {
                this.loading = false;
                this.iframeBridge.sendMessageToChild(IframeId, {
                    type: "auth",
                    data: {
                        token: options.token,
                        parentShopId: options.parentShopId,
                        orderList: options.orderList,
                    }
                })
            })
        },
    }
}
</script>

<style lang="scss">
.print-dialog {
    .el-input, .el-select {
        width: 390px;
    }
    .el-dialog {
        border-radius: 6px;
    }
    .print-dialog-container {
        .el-dialog__header {
            padding: 17px 20px;
        }
        .el-dialog__title {
            font-size: 16px;
            line-height: 21px;
            font-weight: 600;
        }
    }
    .print-dialog-container__printing {
        .el-dialog__header {
            padding: 0;
        }
    }
}
</style>